<template>
  <div class="home">
    <HeaderStyle1>
<!--      <h1 slot="title" v-html="$t('home-head-h1')"></h1>-->
<!--      <p slot="detail" v-html="$t('home-head-small')"></p>-->
<!--      <b-img slot="image" src="../assets/imgs/banner_img_home.jpg" alt="" />-->
<!--      <b-img slot="banner" class="banner" src="../assets/imgs/banner_img_home.jpg" alt="" />-->
    </HeaderStyle1>

    <main class="main-content">
      <b-container fluid="xl" class="section-1">
        <h2 class="section-title">{{$t('section-title-1')}}</h2>
        <h3 class="section-sub-title">{{$t('section-sub-title-1')}}</h3>

        <b-row class="mt-5">
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_healthStep_logo.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-1-img-1-title')}}</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_weather_logo.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-1-img-w-title')}}</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_clean_logo.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-1-img-c-title')}}</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_duoduo.png" fluid alt=""></b-img>
            <span class="image-title">清理加速器多多</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_pcooler.png" fluid alt=""></b-img>
            <span class="image-title">手机降温加速器</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_psd.png" fluid alt=""></b-img>
            <span class="image-title">朝夕美颜P图</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_question_duo.png" fluid alt=""></b-img>
            <span class="image-title">答题多多</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_duoduo_p.png" fluid alt=""></b-img>
            <span class="image-title">天天走路（多多运动计步器）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_song.png" fluid alt=""></b-img>
            <span class="image-title">猜歌趣多多</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_box.png" fluid alt=""></b-img>
            <span class="image-title">攒米盒子</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_muyu.png" fluid alt=""></b-img>
            <span class="image-title">木鱼多多</span>
          </b-col>
        </b-row>

        <h3 class="section-sub-title">{{$t('section-sub-title-2')}}</h3>

        <b-row class="mt-5">
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_healthStep_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-1-title')}}</span>
            <p class="image-detail">{{$t('section-2-img-1-p')}}</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_weather_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">{{$t('section-2-img-w-p')}}</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_clean_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">{{$t('section-2-img-c-p')}}</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_duoduo_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">清理加速器多多Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_duoduo_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">手机降温加速器Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_psd_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">朝夕美颜P图Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_quest_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">答题多多Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_duoduop_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">天天走路（多多运动计步器）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_song_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">猜歌趣多多Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_box_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">攒米盒子Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_muyu_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-2-img-2-title')}}</span>
            <p class="image-detail">木鱼多多Android版</p>
          </b-col>
<!--          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">-->
<!--            <b-img class="image-app-logo" src="../assets/imgs/icon_leStep_logo.png" fluid alt=""></b-img>-->
<!--            <span class="image-title">{{$t('section-2-img-3-title')}}</span>-->
<!--            <p class="image-detail">{{$t('section-2-img-3-p')}}</p>-->
<!--          </b-col>-->
        </b-row>

      </b-container>

      <!--PC端展示-->
<!--      <b-container v-if="!isMobile" fluid="xl" class="section-2">-->
<!--        <h2 class="section-title">{{$t('section-title-2')}}</h2>-->

<!--        <b-row style="margin-top: 60px">-->
<!--          <b-col>-->
<!--            <b-img src="../assets/imgs/home-section-2-img-1.png" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col cols="1"></b-col>-->
<!--          <b-col class="row-content" style="text-align: left">-->
<!--            <h5 class="row-title">{{$t('section-2-row-1-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-1-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 120px">-->
<!--          <b-col class="row-content" style=" text-align: right;">-->
<!--            <h5 class="row-title">{{$t('section-2-row-2-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-2-detail')"></p>-->
<!--          </b-col>-->
<!--          <b-col cols="1"></b-col>-->
<!--          <b-col>-->
<!--            <b-img src="../assets/imgs/home-section-2-img-2.png" fluid></b-img>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 134px">-->
<!--          <b-col style="text-align: right">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-3.png" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col cols="1"></b-col>-->
<!--          <b-col class="row-content" style="text-align: left">-->
<!--            <h5 class="row-title">{{$t('section-2-row-3-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-3-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </b-container>-->
      <!--手机端展示-->
<!--      <b-container v-else class="section-2">-->

<!--        <h2 class="section-title">{{$t('section-title-2')}}</h2>-->

<!--        <b-row style="margin-top: 60px">-->
<!--          <b-col cols="12" class="text-center">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-1.png" style="width: 80%;" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col class="row-content mt-5" style="text-align: center">-->
<!--            <h5 class="row-title">{{$t('section-2-row-1-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-1-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 120px">-->
<!--          <b-col cols="12" class="text-center">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-2.png" style="width: 80%;" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col class="row-content mt-5" style=" text-align: center;">-->
<!--            <h5 class="row-title">{{$t('section-2-row-2-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-2-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 134px">-->
<!--          <b-col cols="12" class="text-center">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-3.png" style="width: 80%;" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col class="row-content mt-5" style="text-align: center">-->
<!--            <h5 class="row-title">{{$t('section-2-row-3-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-3-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--      </b-container>-->
    </main>
  </div>
</template>

<script>
import HeaderStyle1 from '../components/HeaderStyles1.vue'
import runtime from '../utils/runtime'

export default {
  name: 'Home',
  components: {
    HeaderStyle1
  },
  data () {
    return {
      isMobile: runtime.isMobile()
    }
  },
  mounted () {
    document.title = '首页'
  }
}
</script>
<style lang="scss" scoped>
  .home {
    .main-content {
      margin-top: 80px;
      padding-bottom: 100px;

      .section-title {
        font-size: 34px;
        font-weight: 700;
        color: #000000;
      }

      .section-sub-title {
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        line-height: 1.4;
        margin-top: 25px;
      }

      .image-title {
        display: block;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        color: #000000;
        margin-top: 24px;
      }
      .p-4{
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .image-app-logo{

      }

      .image-detail {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 20px;
        margin-top: 24px;
      }

      .section-1{

      }
      .mt-5{
        margin-top: 10px !important;
        margin-top: 10px !important;
      }
      .section-2{
        margin-top: 113px;

        .row-content {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          .row-title {
            font-size: 24px;
            font-weight: 700;
            color: #000000;
          }

          .row-detail {
            font-size: 18px;
            font-weight: 400;
            color: #000000;
            line-height: 1.4;
            margin-top: 31px;
          }
        }
      }
    }

  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .row-title {
      font-size: 20px !important;
    }
    .row-detail {
      font-size: 16px !important;
      margin-top: 10px !important;
    }
    .main-content {
      margin-top: 33px !important;
    }
    .section-title {
      font-size: 20px !important;
      text-align: center;
    }
    .section-sub-title {
      font-size: 12px !important;
      text-align: center;
    }
    .image-title {
      font-size: 14px !important;
      margin-top: 24px;
    }
    .image-detail {
      font-size: 12px !important;
      margin-top: 24px;
    }
  }
</style>
